import type {OrgEditPermissions} from '@github-ui/custom-properties-types'
import {human} from '@github-ui/formatters'
import {Link} from '@github-ui/react-core/link'
import {Box, CounterLabel, TabNav, Text} from '@primer/react'
import type {ComponentProps} from 'react'

export type PropertiesPageTabName = 'set-values' | 'properties'

export function validTabOrDefault(tab: string | null, permissions: OrgEditPermissions): PropertiesPageTabName {
  if (permissions === 'all') {
    return ['set-values', 'properties'].includes(tab || '') ? (tab as PropertiesPageTabName) : 'properties'
  } else if (permissions === 'definitions') {
    return 'properties'
  } else {
    return 'set-values'
  }
}

interface Props {
  activeTab: PropertiesPageTabName
  definitionsCount: number
  hrefBuilder(tab: PropertiesPageTabName): string
}

// Workaround the bug with invalid `activeClassName` prop.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const WrappedLink = ({activeClassName, ...props}: ComponentProps<typeof Link> & {activeClassName?: string}) => (
  <Link {...props} />
)
export function PropertiesPageTabs({hrefBuilder, activeTab, definitionsCount}: Props) {
  return (
    <TabNav aria-label="Page selector" sx={{mb: 3, svg: {color: 'fg.muted'}}}>
      <TabNav.Link as={WrappedLink} to={hrefBuilder('properties')} selected={activeTab === 'properties'}>
        <Box sx={{display: 'flex', gap: 2, alignItems: 'center'}}>
          <Text>Properties</Text>
          <CounterLabel>{human(definitionsCount)}</CounterLabel>
        </Box>
      </TabNav.Link>
      <TabNav.Link as={WrappedLink} to={hrefBuilder('set-values')} selected={activeTab === 'set-values'}>
        <Text>Set values</Text>
      </TabNav.Link>
    </TabNav>
  )
}

try{ WrappedLink.displayName ||= 'WrappedLink' } catch {}
try{ PropertiesPageTabs.displayName ||= 'PropertiesPageTabs' } catch {}